// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planExtendContainer {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.pageTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.planStatusInfo {
  font-size: 18px;
  margin-bottom: 30px;
}

.planExpiry, .daysLeft {
  color: #ff6b00;
  font-weight: bold;
}

/* PlanUpgrade 스타일 재사용 */
.planCards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  width: 100%;
  max-width: 1200px;
}

.planCard {
  flex: 1 1;
  min-width: 300px;
  max-width: 390px;
  height: 480px;
  border-radius: 10px;
  padding: 30px;
  background-color: rgba(255, 111, 15, 0.05);
  display: flex;
  flex-direction: column;
  border: 1px solid #eee;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.planName {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
}

.sizeDescription {
  font-size: 16px;
  color: #666;
  margin-bottom: 15px;
}

/* 캐러셀 스타일 */
.planCarousel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.carouselButton {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  transition: background-color 0.3s;
  color: #333;
}

.carouselButton:hover {
  background-color: #e0e0e0;
}

.planDuration {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;
  position: relative;
}

.planDuration h3 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
}

.mostPopular {
  position: absolute;
  top: 10px;
  right: 10px;
  color: red;
  font-weight: bold;
  font-size: 14px;
}

.planPrice {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
}

.pricePrefix {
  font-size: 16px;
  font-weight: bold;
  color: #666;
  margin-right: 5px;
}

.priceAmount {
  font-size: 36px;
  font-weight: bold;
  color: #333;
}

.priceSuffix {
  font-size: 16px;
  font-weight: bold;
  color: #666;
  margin-left: 5px;
}

.planDetails {
  margin-bottom: 20px;
  width: 100%;
}

.totalPrice, .discountPrice {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.detailLabel {
  color: #666;
  font-size: 14px;
}

.detailValue {
  font-weight: bold;
  font-size: 14px;
}

.highlight {
  color: #3A46B1;
}

.subscribeButton {
  padding: 15px;
  width: 310px;
  height: 80px;
  border: none;
  border-radius: 5px;
  background: rgba(255, 94, 7, 0.15);
  color: black;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  font-weight: bold;
  transition: background 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.subscribeButton:hover {
  background: rgba(255, 94, 7, 0.25);
}

.buttonPrefix {
  font-size: 12px;
  margin-bottom: 5px;
  font-weight: normal;
}

.buttonText {
  font-weight: bold;
}

.smallText {
  font-size: 12px;
  color: #333;
  margin-bottom: 5px;
}

/* 에러 메시지 스타일 */
.errorMessage {
  background-color: #ffebee;
  color: #c62828;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
  text-align: center;
}

.retryButton {
  background-color: #ff6b00;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: bold;
  margin: 0 auto;
  display: block;
}

/* 결제 성공 메시지 스타일 */
.paymentSuccessContainer {
  background-color: white;
  border-radius: 10px;
  padding: 40px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.successIcon {
  width: 100px;
  height: 100px;
  background-color: #f8f9fa;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.successTitle {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.successDetails {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  margin-bottom: 30px;
}

.successDetails p {
  margin: 10px 0;
  font-size: 16px;
  color: #333;
}

.continueButton {
  background-color: #ff6b00;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.continueButton:hover {
  background-color: #e55e00;
}

/* 정보 메시지 스타일 */
.infoMessage {
  background-color: #e8f4fd;
  color: #0277bd;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
  border: 1px solid #b3e5fc;
  max-width: 600px;
  margin: 0 auto;
}

.infoMessage h3 {
  font-size: 20px;
  margin-bottom: 12px;
  color: #01579b;
}

.infoMessage p {
  margin: 8px 0;
  font-size: 16px;
  line-height: 1.5;
} `, "",{"version":3,"sources":["webpack://./src/styles/PlanExtend.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".planExtendContainer {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.pageTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.planStatusInfo {\n  font-size: 18px;\n  margin-bottom: 30px;\n}\n\n.planExpiry, .daysLeft {\n  color: #ff6b00;\n  font-weight: bold;\n}\n\n/* PlanUpgrade 스타일 재사용 */\n.planCards {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n  width: 100%;\n  max-width: 1200px;\n}\n\n.planCard {\n  flex: 1;\n  min-width: 300px;\n  max-width: 390px;\n  height: 480px;\n  border-radius: 10px;\n  padding: 30px;\n  background-color: rgba(255, 111, 15, 0.05);\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #eee;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.planName {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.sizeDescription {\n  font-size: 16px;\n  color: #666;\n  margin-bottom: 15px;\n}\n\n/* 캐러셀 스타일 */\n.planCarousel {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.carouselButton {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: #f0f0f0;\n  border: 1px solid #ddd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 18px;\n  transition: background-color 0.3s;\n  color: #333;\n}\n\n.carouselButton:hover {\n  background-color: #e0e0e0;\n}\n\n.planDuration {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 10px;\n  position: relative;\n}\n\n.planDuration h3 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.mostPopular {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  color: red;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.planPrice {\n  display: flex;\n  align-items: baseline;\n  margin-bottom: 20px;\n}\n\n.pricePrefix {\n  font-size: 16px;\n  font-weight: bold;\n  color: #666;\n  margin-right: 5px;\n}\n\n.priceAmount {\n  font-size: 36px;\n  font-weight: bold;\n  color: #333;\n}\n\n.priceSuffix {\n  font-size: 16px;\n  font-weight: bold;\n  color: #666;\n  margin-left: 5px;\n}\n\n.planDetails {\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.totalPrice, .discountPrice {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.detailLabel {\n  color: #666;\n  font-size: 14px;\n}\n\n.detailValue {\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.highlight {\n  color: #3A46B1;\n}\n\n.subscribeButton {\n  padding: 15px;\n  width: 310px;\n  height: 80px;\n  border: none;\n  border-radius: 5px;\n  background: rgba(255, 94, 7, 0.15);\n  color: black;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: auto;\n  font-weight: bold;\n  transition: background 0.3s ease;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.subscribeButton:hover {\n  background: rgba(255, 94, 7, 0.25);\n}\n\n.buttonPrefix {\n  font-size: 12px;\n  margin-bottom: 5px;\n  font-weight: normal;\n}\n\n.buttonText {\n  font-weight: bold;\n}\n\n.smallText {\n  font-size: 12px;\n  color: #333;\n  margin-bottom: 5px;\n}\n\n/* 에러 메시지 스타일 */\n.errorMessage {\n  background-color: #ffebee;\n  color: #c62828;\n  padding: 12px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.retryButton {\n  background-color: #ff6b00;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-weight: bold;\n  margin: 0 auto;\n  display: block;\n}\n\n/* 결제 성공 메시지 스타일 */\n.paymentSuccessContainer {\n  background-color: white;\n  border-radius: 10px;\n  padding: 40px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  max-width: 600px;\n  width: 100%;\n  margin: 0 auto;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.successIcon {\n  width: 100px;\n  height: 100px;\n  background-color: #f8f9fa;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.successTitle {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 20px;\n}\n\n.successDetails {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 20px;\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n.successDetails p {\n  margin: 10px 0;\n  font-size: 16px;\n  color: #333;\n}\n\n.continueButton {\n  background-color: #ff6b00;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.continueButton:hover {\n  background-color: #e55e00;\n}\n\n/* 정보 메시지 스타일 */\n.infoMessage {\n  background-color: #e8f4fd;\n  color: #0277bd;\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  text-align: center;\n  border: 1px solid #b3e5fc;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.infoMessage h3 {\n  font-size: 20px;\n  margin-bottom: 12px;\n  color: #01579b;\n}\n\n.infoMessage p {\n  margin: 8px 0;\n  font-size: 16px;\n  line-height: 1.5;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
